import React from 'react';
import error from '../../assets/img/error.svg';
import './error.css'

const Error = () => {
  return (
    <div className='error-div'>
      <img src={error} alt="Error Page Not Found"></img>
    </div>
  );
}

export default Error;
